module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "height-100"
  }, [_c('div', {
    staticClass: "display-flex mb-5"
  }, [_c('div', {
    staticClass: "volver display-flex flex-1"
  }, [_c('button', {
    staticClass: "button",
    on: {
      "click": function($event) {
        return _vm.volver()
      }
    }
  }, [_vm._m(0), _c('span', [_vm._v("Volver")])])])]), _c('transition-group', {
    staticClass: "contenedor-box-transition",
    attrs: {
      "name": "fade-smooth-two",
      "tag": "div"
    }
  }, [_c('div', {
    key: "box-cajas",
    staticClass: "box lista-solicitud-vacaciones contenedor-interno"
  }, [_c('div', {
    staticClass: "contenedor-glosa"
  }, [_c('strong', {
    staticClass: "titulo"
  }, [_vm._v(_vm._s(_vm.titulo))]), _c('br'), _c('p', {
    staticClass: "pt-10 descripcion",
    domProps: {
      "innerHTML": _vm._s(_vm.convertirSaltosDeLinea(_vm.descripcion))
    }
  })]), _c('div', {
    staticClass: "display-flex jcc aic"
  }, [(!_vm.fechaInicio) ? _c('button', {
    staticClass: "button is-primary m-5",
    on: {
      "click": function($event) {
        return _vm.iniciarCurso()
      }
    }
  }, [_c('span', {
    staticClass: "icon is-small"
  }, [_c('i', {
    staticClass: "fa fa-check is-small"
  })]), _c('span', [_vm._v("Iniciar curso")])]) : _vm._e()]), (_vm.showMateriales || _vm.showEvaluaciones) ? _c('div', {
    staticClass: "display-flex fdr space-evenly flex-wrap"
  }, [(_vm.showMateriales) ? _c('div', {
    staticClass: "caja lista-solicitud-vacaciones contenedor-interno"
  }, [_c('materiales-clase-lista', {
    attrs: {
      "modulo": 'alumno',
      "type": 'curso',
      "fetchURL": _vm.fetchURLMaterial
    },
    on: {
      "close": function($event) {
        return _vm.close('showMateriales')
      }
    }
  })], 1) : _vm._e(), (_vm.showEvaluaciones) ? _c('div', {
    staticClass: "caja lista-solicitud-vacaciones contenedor-interno"
  }, [_c('evaluaciones-clase-lista', {
    attrs: {
      "modulo": 'alumno',
      "type": 'curso',
      "fetchURL": _vm.fetchURLEvaluacion
    },
    on: {
      "close": function($event) {
        return _vm.close('showEvaluaciones')
      }
    }
  })], 1) : _vm._e()]) : _vm._e()]), _c('div', {
    key: "box-lista",
    staticClass: "box lista-solicitud-vacaciones contenedor-interno"
  }, [_c('c-lista-cursos-virtuales-clases')], 1)])], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "icon"
  }, [_c('i', {
    staticClass: "fa fa-arrow-left"
  })])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-2d15eee2","hasScoped":true}!./~/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/View_Cursos_Virtuales_Clases.vue
// module id = 850
// module chunks = 0